import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getEmployeeFiltred,
  getSalaireEmp,
  getEmployeeSalaryWitoutPresenceAndUpdateHisPrime,
  generateFicheDePaie,
} from "../../../../services/RHService/PaiementService";
import { getPrimeByUser } from "../../../../services/RHService/PrimeService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import "toastr/build/toastr.min.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import PaimentwithSelectionComp from "./PaimentwithSelectionComp";
import withLoader from "../../../../components/layouts/WithLoader";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";

const FicheDePaieSelonSalaire = ({startLoading,stopLoading}) => {
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormDataInfo({ ...formDataInfo, [name]: value });
  };

  // fin :the card of search by month and year

  //recherche
  const [employees, setEmployees] = useState([]);
  const [filter, setFilter] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const filteredData1 = employees
    ? employees.filter(
        (item) =>
          (item.cin && item.cin.toLowerCase().includes(filter.toLowerCase())) ||
          (item.firstName &&
            item.firstName.toLowerCase().includes(filter.toLowerCase())) ||
          (item.lastName &&
            item.lastName.toLowerCase().includes(filter.toLowerCase()))
      )
    : [];

  useEffect(() => {
    getEmployeeFiltred(getCurrentUserId(), filter).then((data) =>
      setEmployees(data.success)
    );
  }, [filter]);

  const [selectedUsers, setSelectedUsers] = useState([]);

  //recherche
  // début pagination
  const [itemsPerPage, setItemsPerPage] = useState(5); // Nombre d'éléments par page
  const [currentPage, setCurrentPage] = useState(1); // Numéro de la page actuelle

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  // Fonction pour passer à la page précédente
  const previousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };
  // Fonction pour changer le nombre d'éléments par page
  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1); // Réinitialiser la page actuelle à 1
  };


  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleShow = (employee) => {
    setSelectedEmployee(employee);
    setShow(true);
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  //handle the steps
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;
  const handlePrevious = () => {
    setCurrentStep(currentStep - 1); // Met à jour la valeur de currentStep en décrémentant de 1
  };
  const handleNext = () => {
    if(currentStep===1){
      fetchDataInfo().then(() => {
        setLoadingForInfo(false);
      });
      setCurrentStep(currentStep + 1);

    }else{
      setCurrentStep(currentStep + 1);

    }

  };
  //step 1 : the month and year
  const [formDataInfo, setFormDataInfo] = useState({
    dateDeb: "",
    dateFin: "",
    userPrimeModel: [],
  });

  // useEffect(() => {}, [formDataInfo]);

  const isValidSelection = () => {
    return formDataInfo.dateDeb !== "" && formDataInfo.dateFin !== "";
  };
  //step 2 : General info
  const [loadingForInfo, setLoadingForInfo] = useState(true);

  const [Infos, setInfos] = useState();

  // useEffect(() => {
  //   fetchDataInfo().then(() => {
  //     setLoadingForInfo(false);
  //   });
  // }, [selectedEmployee, formDataInfo.dateDeb, formDataInfo.dateFin]);

  const fetchDataInfo = async () => {
    if (
      selectedEmployee &&
      selectedEmployee.idUser &&
      formDataInfo.dateDeb &&
      formDataInfo.dateFin
    ) {
      const data = await getSalaireEmp(
        formDataInfo.dateDeb,
        formDataInfo.dateFin,
        selectedEmployee.idUser,getCurrentUserId()
      );
      setInfos(data.success);
    }
  };

  //step 3 : les primes

  const [prime, setPrime] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchData().then(() => {
      setLoading(false);
    });
  }, [selectedEmployee]);
  const fetchData = async () => {
    if (selectedEmployee && selectedEmployee.idUser) {
      const data = await getPrimeByUser(selectedEmployee.idUser);
      setPrime(data.success);
    }
  };

  //set the inputList by the default prime of user
  const [inputList, setInputList] = useState([]);

  useEffect(() => {
    if (prime.length > 0) {
      setInputList(
        prime
          .filter((c) => c.primeAmount !== null)
          .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }))
      );
    }
  }, [prime]);

  // input: is affected
  const handleCheckboxChange = (index) => {
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, isAffected: !c.isAffected } : c
    );
    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    if (
      updatedPrime[index].idPrime === "inputCheck" &&
      updatedPrime[index].isAffected
    ) {
      updatedInputList.push({ idPrime: "inputCheck", primeAmount: "" });
    }

    setInputList(updatedInputList);
  };

  const handlePrimeAmountChange = (event, index) => {
    const { value } = event.target;
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, primeAmount: value || "" } : c
    );

    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    const additionalInputs = updatedPrime.filter(
      (c) => c.idPrime === "inputCheck" && c.isAffected
    );
    additionalInputs.forEach((input) => {
      updatedInputList.push({ idPrime: input.idPrime, primeAmount: "" });
    });

    setInputList(updatedInputList);
  };
  const [heureSupp, setHeureSupp] = useState({ heureSupp: 0 });
  const handleSuppHeureChange = (event) => {
    const { value } = event.target;
    setHeureSupp({ heureSupp: value });
  };
  //set the formData by the inputList
  useEffect(() => {
    setFormDataInfo((prevState) => ({
      ...prevState,
      userPrimeModel: inputList,
    }));
    console.log(inputList);
  }, [inputList]);
  //the steps
  const renderModalContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Container className="d-flex justify-content-center align-items-center">
            <Row>
              <Col xs={12} md={4}>
                <label htmlFor=""> Choisir la periode</label>
              </Col>
              <Col xs={12} md={8}>
                <div className="row">
                  <div className="col-md-6 mx-3 mt-2">
                    <input
                      className="form-control input-date"
                      style={{ paddingLeft: "6px" }}
                      type="date"
                      min="1900-01-01"
                      max="2500-12-31"
                      id="month"
                      name="dateDeb"
                      onChange={handleInputChange}
                      value={formDataInfo.dateDeb || ""}
                    />
                  </div>

                  <div className="col-md-6 mx-3 mt-2">
                    <input
                      className="form-control input-date"
                      style={{ paddingLeft: "6px" }}
                      type="date"
                      min="1900-01-01"
                      max="2500-12-31"
                      id="year"
                      name="dateFin"
                      onChange={handleInputChange}
                      value={formDataInfo.dateFin || ""}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        );
      case 2:
        return (
          <Container>
            <Row>
              <Col xs={12} md={12}>
                <input
                  hidden
                  name="idUser"
                  value={
                    selectedEmployee && selectedEmployee.idUser
                      ? selectedEmployee.idUser
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedEmployee({
                      ...selectedEmployee,
                      idUser: e.target.value,
                    })
                  }
                />
                <label>Informations générales</label>
                {loadingForInfo ? (
                  <div className="loader center"></div>
                ) : (
                  <>
                    {Infos && Infos.map((info, index) => (
                      <div key={index} className="info-container">
                        <div className="info">
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Personnel:</label>{" "}
                                {info.firstName} {info.lastName}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Nom Contrat:</label>{" "}
                                {info.nomContrat}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Nom Post:</label>{" "}
                                {info.nomPost}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Heures travaillé:</label>{" "}
                                {info.heureDeTravail} heures{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Heures supplimentaire:
                                </label>{" "}
                                {info.suppHours || 0} heures{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Salaire de base :</label>{" "}
                                {info.salaireDeBase} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Totale Primes :</label>{" "}
                                {info.totprimes || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Salaire Brut :</label>{" "}
                                {info.salaireBrut || info.salaryWithAdvantage}{" "}
                                DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Cotisation CNSS :</label>{" "}
                                {info.cnssContribution || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Salaire Imposable :
                                </label>{" "}
                                {info.salaireImposable || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Impôt sur le revenu:
                                </label>{" "}
                                {info.taxIR || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">
                                  Salaire apres Impot:
                                </label>{" "}
                                {info.salaryAfterTax || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>

                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Cotisation CSS :</label>{" "}
                                {info.cssContribution || "--"} DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Net A payé :</label>{" "}
                                {info.salaryAfterTax }{" "}
                                DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                          {/* <p>
                            {info ? (
                              <span>
                                {" "}
                                <label htmlFor="">Net à payé:</label>{" "}
                                {info.salaryAfterTax ||
                                  info.salaryWithAdvantage}{" "}
                                DT{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </p> */}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </Col>
            </Row>
          </Container>
        );

      default:
        return (
          <Container>
            <Row>
              <Col xs={12} md={6}>
                <input
                  hidden
                  name="idUser"
                  value={
                    selectedEmployee && selectedEmployee.idUser
                      ? selectedEmployee.idUser
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedEmployee({
                      ...selectedEmployee,
                      idUser: e.target.value,
                    })
                  }
                />
                {loading ? (
                  <div className="loader center"></div>
                ) : (
                  <div>
                    {prime.length !== 0 && (
                      <div>
                        {prime.map((c, index) => (
                          <div key={c.idPrime} className="row">
                            <div className="col-md-6 icheck-dark d-inline mx-1">
                              <input
                                type="checkbox"
                                id={c.nomPrime}
                                value={c.idPrime}
                                name="idPrime"
                                checked={c.isAffected}
                                onChange={() => handleCheckboxChange(index)}
                              />
                              <label htmlFor={c.nomPrime}>{c.nomPrime}</label>
                            </div>
                            <div className="col-md mx-1 mt-1">
                              <input
                                type="text"
                                className="form-control"
                                onChange={(event) =>
                                  handlePrimeAmountChange(event, index)
                                }
                                name="primeAmount"
                                value={c.primeAmount || ""}
                                placeholder="Montant de Prime"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                <div className="col-md mx-1 mt-1">
                  <input
                    type="text"
                    className="form-control"
                    onChange={(event) => handleSuppHeureChange(event)}
                    name="heureSupp"
                    value={heureSupp.heureSupp || ""}
                    placeholder="Tapez les heures Supplimentaires"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        );
    }
  };
  useEffect(() => {}, [formDataInfo]);

  const [finalInfo, setFinalInfo] = useState([]);



  const onUploadFileHandler = (idFichedePaie) => {
    startLoading();
    generateFicheDePaie(getCurrentUserId(), idFichedePaie).then(
      (response) => {
        console.log("response", response);
        handleClose()

        onShowFileInOtherWizndowHandler(response.data?.path);
      }
    ).finally(()=>{
      stopLoading();
    });
  };

  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error);
      });
  };
  const handleSubmit =  (event) => {

    if (currentStep < totalSteps) {
      handleNext(); 
    } else {
      console.log(heureSupp);

      if (
        selectedEmployee &&
        selectedEmployee.idUser &&
        formDataInfo.dateDeb &&
        formDataInfo.dateFin
      ) {

          getEmployeeSalaryWitoutPresenceAndUpdateHisPrime(
            heureSupp.heureSupp,
            selectedEmployee.idUser,
            getCurrentUserId(),
            formDataInfo.dateDeb,
            formDataInfo.dateFin,
            formDataInfo.userPrimeModel
          ).then((resp)=>{
            console.log(resp)
            setFinalInfo(resp.salaryModel);
            if(resp.salaryModel.urlFile===null||resp.salaryModel.urlFile==="any"){
              onUploadFileHandler(resp.salaryModel.idSalary);
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succée ");
            }else{
              handleClose()

              onShowFileInOtherWizndowHandler(resp.salaryModel.urlFile);
              setOpenSuccessAlert(true);
              setSuccessAlertText("Mise à jour avec succée ");
            }
           

          }).catch((error)=>{
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : "+error);
          })

       
      }
    }
  };
  useEffect(() => {
    if (formDataInfo.dateDeb && formDataInfo.dateFin) {
    }
  }, [finalInfo]);

 
  //Partie 3 :lorsqu'il select des user
  const handleUserSelection = (event, userId) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedUsers((prevSelectedUsers) => [...prevSelectedUsers, userId]);
    } else {
      setSelectedUsers((prevSelectedUsers) =>
        prevSelectedUsers.filter((selectedUserId) => selectedUserId !== userId)
      );
    }
  };

  useEffect(() => {}, [selectedUsers]);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Visualisation de bulletin </h1>
              <hr></hr>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Fiche de Paie</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Étapes pour générer la fiche de paie</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Form onSubmit={handleSubmit}>{renderModalContent()}</Form>
        </Modal.Body>
        <Modal.Footer>
          {currentStep > 1 && (
            <Button variant="secondary" onClick={handlePrevious}>
              Précédent
            </Button>
          )}
          <Button
            variant="dark"
            onClick={currentStep < totalSteps ? handleNext : handleSubmit}
            disabled={!isValidSelection()}
          >
            {currentStep < totalSteps ? "Suivant" : "Terminer"}
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="search center mx-3 mt-3 mb-3">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Rechercher..."
                    value={filter}
                    onChange={(e) => {
                      setFilter(e.target.value);
                      setIsVisible(true);
                    }}
                  />
                </div>

                {isVisible && (
                  <div className="table-responsive">
                    {filteredData1.length === 0 ? (
                      <p style={{ textAlign: "center" }}>
                        Pas de résultat, veuillez vérifier !
                      </p>
                    ) : (
                      <table className="table">
                        <thead className="thead-dark">
                          <tr>
                            <th scope="col">Select</th>
                            <th scope="col">Mat.</th>
                            <th scope="col">Personnel</th>
                            <th scope="col">CIN</th>
                            <th scope="col">Fiche de paie</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData1
                            .slice(
                              (currentPage - 1) * itemsPerPage,
                              currentPage * itemsPerPage
                            )
                            .map((employee, index) => (
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    id={employee.idUser}
                                    value={employee.idUser}
                                    onChange={(e) =>
                                      handleUserSelection(e, employee.idUser)
                                    }
                                  />
                                  <label htmlFor={employee.idUser}></label>
                                </td>
                                <td>{index + 1}</td>
                                <td>
                                  {employee.firstName} {employee.lastName}
                                </td>
                                <td>{employee.cin}</td>
                                <td class="button-container">
                                  <button
                                    onClick={() => {
                                      handleShow(employee);
                                    }}
                                    type="button"
                                    class="files-style"
                                  >
                                    <i class="fa-solid fa-file file-icon"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}

                {isVisible ? (
                  filteredData1.length > 0 ? (
                    <>
                      <div className="pagination">
                        <button
                          className="button-paiement"
                          onClick={previousPage}
                          disabled={currentPage === 1}
                        >
                          Précédent
                        </button>
                        <span className="mx-2">{currentPage}</span>
                        <button
                          className="button-paiement"
                          onClick={nextPage}
                          disabled={
                            currentPage ===
                            Math.ceil(filteredData1.length / itemsPerPage)
                          }
                        >
                          Suivant
                        </button>
                      </div>

                      <select
                        className="select-box-card2"
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                      >
                        <option className="center" value={5}>
                          5
                        </option>
                        <option className="center" value={10}>
                          10
                        </option>
                        <option className="center" value={20}>
                          20
                        </option>
                        <option className="center" value={50}>
                          50
                        </option>
                      </select>
                    </>
                  ) : null
                ) : (
                  <p style={{ textAlign: "center" }}></p>
                )}
              </div>

              <PaimentwithSelectionComp
                selectedUsers={selectedUsers}
                isVisible={isVisible}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(FicheDePaieSelonSalaire);
